// Nurture · status pill + email card. Both tiny, pure-presentational.
import React from "react";
import { Badge } from "../ui/badge";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Ban, CheckCircle2, Clock } from "lucide-react";

const DAY_LABELS = { 0: "Day 0 — sent immediately", 3: "Day 3 — follow-up", 7: "Day 7 — soft CTA" };

export function StatusPill({ status }) {
  if (status === "sent") return <Badge className="bg-emerald-500/15 text-emerald-300 border-emerald-500/40"><CheckCircle2 className="w-3 h-3 mr-1" /> Sent</Badge>;
  if (status === "scheduled") return <Badge className="bg-accent/15 text-accent border-accent/40"><Clock className="w-3 h-3 mr-1" /> Scheduled</Badge>;
  if (status === "cancelled") return <Badge variant="outline" className="text-muted-foreground"><Ban className="w-3 h-3 mr-1" /> Cancelled</Badge>;
  return <Badge variant="outline" className="text-muted-foreground">Draft</Badge>;
}

export function NurtureEmailCard({ email, onChange }) {
  const locked = email.status === "sent" || email.status === "cancelled";
  return (
    <div className="border border-border/60 rounded-md p-4" data-testid={`nurture-email-${email.day}`}>
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="overline">{DAY_LABELS[email.day] || `Day ${email.day}`}</div>
        <div className="flex items-center gap-2">
          <StatusPill status={email.status} />
          {email.send_at && email.status !== "sent" && (
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
              send {new Date(email.send_at).toLocaleString()}
            </span>
          )}
          {email.sent_at && email.status === "sent" && (
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
              sent {new Date(email.sent_at).toLocaleString()}
            </span>
          )}
        </div>
      </div>
      <label className="text-xs uppercase tracking-widest text-muted-foreground">Subject</label>
      <Input
        data-testid={`nurture-subject-${email.day}`}
        value={email.subject || ""}
        readOnly={locked}
        onChange={(ev) => onChange({ subject: ev.target.value })}
        className="mt-1.5 mb-3"
      />
      <label className="text-xs uppercase tracking-widest text-muted-foreground">Body</label>
      <Textarea
        data-testid={`nurture-body-${email.day}`}
        value={email.body || ""}
        readOnly={locked}
        onChange={(ev) => onChange({ body: ev.target.value })}
        className="mt-1.5 min-h-[180px] font-mono text-sm leading-relaxed"
      />
    </div>
  );
}
